import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { RequestService } from 'app/core/services/request.service';
import { ConfigService } from 'app/core/services/config.service';

@Injectable()
export class ProductService {

    constructor(
        private requestService: RequestService,
        private configService: ConfigService
    ) {
    }

    activateVariants(ids: string[]): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').solar.productVariant.activate.api;
        return this.requestService.post(url, ids);
    }

    getProductGroups(sort: number, URLParams?: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').solar.product.productGroup.api;

        let params = URLParams ? URLParams : {};
        if (sort == -1 || sort == 1) params['$name'] = sort;
        return this.requestService.get(url, params);
    }

    getProductsByGroups(groups: any[], sort: number): Observable<any> {
        let query = groups
            .map(group => group.id)
            .reduce((queryStr, id) => `${queryStr}&productGroupId=${id}`, '?');

        if (sort == 1 || sort == -1) query += `&$name=${sort}`;

        let url = this.configService.get('server').url + this.configService.get('endpoints').solar.product.product.api + query;
        return this.requestService.get(url);
    }

    getVariantsByProducts(products: any[], sort: number): Observable<any> {
        let query = products
            .map(prod => prod.agoraProductVariant.id)
            .reduce((queryStr, id) => `${queryStr}&productId=${id}`, '?');

        if (sort == 1 || sort == -1) query += `&$fullName=${sort}`;

        let url = this.configService.get('server').url + this.configService.get('endpoints').solar.product.productVariant.api + query;
        return this.requestService.get(url);
    }
}


// WEBPACK FOOTER //
// ./src/app/solar/common/services/product.service.ts